/** Сетка проходимости зоны. Рендер про неё не знает — это чистые данные. */

export interface Point {
  x: number;
  y: number;
}

export interface Grid {
  width: number;
  height: number;
  /** 1 — занято (дом, забор, машина), 0 — можно ходить. */
  blocked: Uint8Array;
}

export function createGrid(width: number, height: number): Grid {
  return { width, height, blocked: new Uint8Array(width * height) };
}

export function inBounds(grid: Grid, x: number, y: number): boolean {
  return x >= 0 && y >= 0 && x < grid.width && y < grid.height;
}

export function isWalkable(grid: Grid, x: number, y: number): boolean {
  return inBounds(grid, x, y) && grid.blocked[y * grid.width + x] === 0;
}

export function setBlocked(grid: Grid, x: number, y: number, blocked = true): void {
  if (!inBounds(grid, x, y)) return;
  grid.blocked[y * grid.width + x] = blocked ? 1 : 0;
}

/** Прямоугольник под здание разом. */
export function blockRect(grid: Grid, x: number, y: number, w: number, h: number): void {
  for (let dy = 0; dy < h; dy++) {
    for (let dx = 0; dx < w; dx++) setBlocked(grid, x + dx, y + dy, true);
  }
}

/** Ближайшая проходимая клетка — когда игрок кликнул в стену. */
export function nearestWalkable(grid: Grid, from: Point, maxRadius = 6): Point | null {
  if (isWalkable(grid, from.x, from.y)) return from;
  for (let r = 1; r <= maxRadius; r++) {
    for (let dy = -r; dy <= r; dy++) {
      for (let dx = -r; dx <= r; dx++) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) !== r) continue;
        const x = from.x + dx;
        const y = from.y + dy;
        if (isWalkable(grid, x, y)) return { x, y };
      }
    }
  }
  return null;
}
